














import PopupEpisode2 from '@/views/templates/tenugui/PopupEpisode2.vue'

export default
  components: {
    PopupEpisode2
  }

  methods: {
    closePopup: () ->
      @$emit('closePopup')
  }
